import * as z from "zod";
import { requiredString } from "components/form/utils";

export const currenciesSchema = z.object({
  name: requiredString(),
  budget_rate_inr: z.number({ invalid_type_error: "Must be a number" }).positive("Must be greater than 0").optional(),
  budget_rate_usd: z.number({ invalid_type_error: "Must be a number" }).positive("Must be greater than 0").optional(),
  status: z.optional(z.string()).default("draft"),
});
